import TennisTable from "./TennisTable";
export const firstTennisSection = [
  {
    name: "Row 1",
    left: [],
    right: [
      { column1: "Overall Size", column2: "156ft x 120ft" },
      { column1: "Total Area", column2: "18,720 sq.ft./2,080 sq.yds" },
      { column1: "Playing Area", column2: "8,424 sq.ft./936 sq.yds" },
      { column1: "Outside Court Area", column2: "10,296 sq.ft./1,144 sq.yds" },
    ],
  },
];

export const secondTennisSection = [
  {
    name: "Row 2",
    left: ["Acrylic Resurfacer", "Acrylic Resurfacer With Sand"],
    right: [
      { column1: "One Coat", column2: "150 Gallons" },
      { column1: "One Coat", column2: "230 Gallons" },
    ],
  },
];

export const thirdTennisSection = [
  {
    name: "Row 3",
    left: [
      "Color /Neutral Concentrate",
      "Color/Neutral Concentrate w/Sand",
      "Color /Neutral Concentrate Ready-Mix Color",
    ],
    right: [
      { column1: "Two Coats", column2: "95 Gallons" },
      { column1: "Two Coats", column2: "135 Gallons" },
      { column1: "Two Coats", column2: "225 Gallons" },
    ],
  },
];

export const forthTennisSection = [
  {
    name: "Row 4",
    left: [
      "Color /Neutral Concentrate",
      "Color/Neutral Concentrate w/Sand",
      "Color /Neutral Concentrate Ready-Mix Color",
    ],
    right: [
      { column1: "Two Coats", column2: "120 Gallons" },
      { column1: "Two Coats", column2: "165 Gallons" },
      { column1: "Two Coats", column2: "275 Gallons" },
    ],
  },
];

export const fifthTennisSection = [
  {
    name: "Row 5",
    left: ["CushionMaster II (Coarse Rubber)", "CushionMaster I (Fine Rubber)"],
    right: [
      { column1: "Three Coats", column2: "940 Gallons" },
      { column1: "Two Coats", column2: "420 Gallons" },
    ],
  },
];

export const sixthTennisSection = [
  {
    name: "Row 6",
    left: ["Stripe Rite", "White Line Paint"],
    right: [
      { column1: "One Coat", column2: "3 Gallons" },
      { column1: "One Coat", column2: "3 Gallons" },
    ],
  },
];

export const sevenTennisSection = [
  {
    name: "Row 7",
    left: ["Standard Size Roll"],
    right: [{ column1: "24 Rolls" }],
  },
];

const TennisThreeCourt = () => {
  return (
    <>
      <TennisTable rows={firstTennisSection} hidden={true} />
      <TennisTable
        rows={secondTennisSection}
        leftCol={"Total Area"}
        middleCol={"Coats"}
        rightCol={"Gallon Needed"}
      />
      <TennisTable
        rows={thirdTennisSection}
        leftCol={"Inside Area"}
        middleCol={"Coats"}
        rightCol={"Gallon Needed"}
      />
      <TennisTable
        rows={forthTennisSection}
        leftCol={"Outside Area"}
        middleCol={"Coats"}
        rightCol={"Gallon Needed"}
      />
      <TennisTable
        rows={fifthTennisSection}
        leftCol={"ProCushion LAYERS"}
        middleCol={"Coats"}
        rightCol={"Gallon Needed"}
      />
      <TennisTable
        rows={sixthTennisSection}
        leftCol={"STRIPING"}
        middleCol={"Coats"}
        rightCol={"Gallon Needed"}
      />
      <TennisTable
        rows={sevenTennisSection}
        leftCol={"MASKING TAPE"}
        middleCol={"Rolls Needed"}
      />
    </>
  );
};

export default TennisThreeCourt;
